import { formatUsd } from "@lumora/core";
export function adminOrderRows(orders, variant = "site") {
    return orders.map((o) => {
        const row = [
            String(o.number),
            o.customerName,
            o.pickupTime,
            o.status,
        ];
        if (variant === "ops")
            row.push(o.channel);
        row.push(formatUsd(o.totalCents));
        row.push(variant === "ops"
            ? new Date(o.createdAt).toLocaleTimeString()
            : new Date(o.createdAt).toLocaleString());
        return row;
    });
}
export function adminEventRows(events) {
    return events.map((e) => [e.type, e.message, new Date(e.createdAt).toLocaleString()]);
}
export function adminDeviceRows(devices) {
    return devices.map((d) => [
        d.name,
        d.firmwareVersion || "—",
        d.lastSeenAt ? new Date(d.lastSeenAt).toLocaleString() : "never",
    ]);
}
export function adminPaymentRows(payments) {
    return payments.map((p) => [
        formatUsd(p.amountCents),
        p.method,
        p.kind,
        p.note || "—",
        new Date(p.createdAt).toLocaleString(),
    ]);
}
//# sourceMappingURL=platformRows.js.map